export default __webpack_public_path__ + "71be031ffb04ba59c603bfbe53a2aab5.otf";